(function () {
  function detectCurrency(locale) {
    return locale === "fr" ? "EUR" : "USD";
  }

  function formatMoney(cents, locale) {
    try {
      const currency = detectCurrency(locale);
      return new Intl.NumberFormat(locale === "fr" ? "fr-FR" : "en-US", {
        style: "currency",
        currency,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  async function fetchRecommendations(productId, limit, intent) {
    const url = `/recommendations/products.json?product_id=${encodeURIComponent(
      productId
    )}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}`;

    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`Recommendations failed: ${res.status}`);
    return await res.json(); // { products: [...] }
  }

  async function fetchProductJSON(handle) {
    const res = await fetch(`/products/${handle}.js`, {
      headers: { Accept: "application/json" }
    });
    if (!res.ok) throw new Error(`Failed /products/${handle}.js`);
    return await res.json();
  }

  async function addToCart(variantId, qty) {
    // 1) Tentative JSON
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error("JSON add failed: " + txt);
      }
      return await res.json();
    } catch (err) {
      // 2) Fallback form-urlencoded (marche sur tout)
      const formData = new FormData();
      formData.append("id", String(variantId));
      formData.append("quantity", String(qty || 1));

      const res2 = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      });

      if (!res2.ok) {
        const txt2 = await res2.text().catch(() => "");
        throw new Error("Form add failed: " + txt2);
      }
      return await res2.json();
    }
  }

  // ✅ Met à jour la pastille panier de TON thème
  async function refreshCartBadge() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!res.ok) return;

      const cart = await res.json();
      const count = Number(cart.item_count || 0);

      // ✅ Ton badge est .cart-item-amount (vu dans DevTools)
      const badge = document.querySelector(".cart-item-amount");

      if (badge) {
        badge.textContent = String(count);

        // si 0 → on cache
        if (count === 0) {
          badge.style.display = "none";
        } else {
          // ton badge utilise flex dans le thème
          badge.style.display = "flex";
        }
      }
    } catch (e) {
      console.warn("[pairs-with] refreshCartBadge failed", e);
    }
  }

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, (m) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[m];
    });
  }

  function renderCard(product, locale) {
    const v =
      (product.variants || []).find((x) => x.available) ||
      (product.variants || [])[0];

    const img =
      (product.images && product.images.length ? product.images[0] : "") ||
      product.featured_image ||
      "";

    const price = v ? formatMoney(v.price, locale) : "";
    const compareAt =
      v && v.compare_at_price ? formatMoney(v.compare_at_price, locale) : null;

    const soldOut = !v || !v.available;

    return `
      <div class="pairs-with__card">
        <a class="pairs-with__media" href="${product.url}">
          ${img ? `<img src="${img}" alt="${escapeHtml(product.title)}" loading="lazy">` : ""}
        </a>

        <div class="pairs-with__info">
          <a class="pairs-with__title" href="${product.url}">${escapeHtml(product.title)}</a>

          <div class="pairs-with__price">
            <span class="pairs-with__price-current">${price}</span>
            ${compareAt ? `<span class="pairs-with__price-compare">${compareAt}</span>` : ""}
          </div>

          <button
            class="pairs-with__btn"
            type="button"
            data-pairs-add
            data-variant-id="${v ? v.id : ""}"
            ${soldOut ? "disabled" : ""}
          >
            ${
              soldOut
                ? locale === "fr"
                  ? "Indisponible"
                  : "Sold out"
                : locale === "fr"
                ? "Ajouter"
                : "Add"
            }
          </button>
        </div>
      </div>
    `;
  }

  async function initContainer(container) {
    // évite double init
    if (container.dataset.pairsInit === "1") return;
    container.dataset.pairsInit = "1";

    const productId = container.dataset.productId;
    const limit = Number(container.dataset.limit || 2);
    const intent = container.dataset.intent || "complementary";
    const locale = container.dataset.locale || "en";

    try {
      // 1) recos (Search & Discovery)
      const recData = await fetchRecommendations(productId, limit, intent);
      const recProducts = recData && recData.products ? recData.products : [];

      if (!recProducts.length) {
        container.innerHTML = `<div class="pairs-with__empty">${
          locale === "fr" ? "Aucune recommandation." : "No recommendations."
        }</div>`;
        return;
      }

      // 2) fetch /products/{handle}.js pour prix/variants/images
      const handles = recProducts
        .map((p) => p.handle)
        .filter(Boolean)
        .slice(0, limit);

      const fullProducts = [];
      for (const h of handles) {
        try {
          const p = await fetchProductJSON(h);
          fullProducts.push(p);
        } catch (e) {
          // ignore
        }
      }

      if (!fullProducts.length) {
        container.innerHTML = `<div class="pairs-with__empty">${
          locale === "fr" ? "Aucune recommandation." : "No recommendations."
        }</div>`;
        return;
      }

      // 3) render
      container.innerHTML = `
        <div class="pairs-with__grid">
          ${fullProducts
            .slice(0, limit)
            .map((p) => renderCard(p, locale))
            .join("")}
        </div>
      `;

      // Prevent clicks inside the module from collapsing the parent drawer
      // IMPORTANT: no capture=true, otherwise it blocks the button click itself
      container.addEventListener("click", (e) => {
        // Liens: on laisse naviguer mais on évite le toggle du drawer
        if (e.target.closest("a")) {
          e.stopPropagation();
          return;
        }
        // Tout le reste: évite le toggle
        e.stopPropagation();
      });

      // 4) Bind add-to-cart
      container.querySelectorAll("[data-pairs-add]").forEach((btn) => {
        btn.addEventListener(
          "click",
          async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const variantId = Number(btn.dataset.variantId);
            if (!variantId) {
              console.warn("[pairs-with] Missing variant id");
              return;
            }

            const original = btn.textContent;
            btn.disabled = true;
            btn.textContent = locale === "fr" ? "Ajout…" : "Adding…";

            try {
              await addToCart(variantId, 1);

              // ✅ update pastille IMMEDIATEMENT
              await refreshCartBadge();

              // Events “safe” (si ton thème écoute)
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              document.dispatchEvent(new CustomEvent("cart:updated"));
              document.dispatchEvent(new CustomEvent("cart:open"));

              btn.textContent = locale === "fr" ? "Ajouté ✓" : "Added ✓";
            } catch (err) {
              console.error("[pairs-with] addToCart failed", err);
              btn.textContent = locale === "fr" ? "Erreur" : "Error";
            } finally {
              setTimeout(() => {
                btn.textContent = original;
                btn.disabled = false;
              }, 1200);
            }
          },
          { passive: false }
        );
      });
    } catch (e) {
      container.innerHTML = `<div class="pairs-with__empty">${
        locale === "fr" ? "Aucune recommandation." : "No recommendations."
      }</div>`;
      console.error("[pairs-with] error:", e);
    }
  }

  function initAll() {
    document.querySelectorAll("[data-pairs-with]").forEach(initContainer);
  }

  function lockDrawerOpen(drawerId) {
    const el = document.getElementById(drawerId);
    if (!el) return;

    // Cas 1: <details>
    if (el.tagName === "DETAILS") {
      el.open = true;

      el.addEventListener("toggle", () => {
        if (!el.open) el.open = true;
      });

      const summary = el.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", (e) => {
          e.preventDefault();
          el.open = true;
        });
      }
      return;
    }

    // Cas 2: div custom (fallback)
    const header = el.querySelector(
      ".drawer-title, [data-drawer-toggle], .drawer__title"
    );
    if (header) {
      header.addEventListener(
        "click",
        (e) => {
          e.stopPropagation();
          e.preventDefault();
        },
        true
      );
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAll();
    lockDrawerOpen("pairs-with-drawer");

    // au chargement, on sync aussi la pastille
    refreshCartBadge();
  });

  // Shopify theme editor recharge des sections sans recharger la page
  document.addEventListener("shopify:section:load", () => {
    initAll();
    refreshCartBadge();
  });
  document.addEventListener("shopify:section:reorder", () => {
    initAll();
    refreshCartBadge();
  });
})();